import { makeStyles } from "@mui/styles";

import SecondaryButton from "@/components/UI/SecondaryButton/SecondaryButton";
import { ELEMENT_FORM_STATE } from "@/constants/";

import AudioPlayback from "../AudioPlayback/AudioPlayback";

const useStyles = makeStyles({
  preview: {
    display: "flex",
    alignItems: "center",
    gap: "32px",
  },
});

export default function AudioPreview(props) {
  const { elementFormState, previewUrl, replace, type } = props;

  const classes = useStyles();

  return (
    <>
      {elementFormState === ELEMENT_FORM_STATE.PREVIEW && (
        <div className={classes.preview}>
          <AudioPlayback url={previewUrl} />
          <SecondaryButton style={{ width: "94px" }} onClick={replace} data-analytics={`${type}-button-replace`}>
            Replace
          </SecondaryButton>
        </div>
      )}
    </>
  );
}
